/**
 * Client portal Tasks (DD-053): the token client's client-visible tasks.
 * The client id comes from the portal JWT. People and saves go through
 * tasksService, whose portal branch the shared drawer already uses.
 */

import type { HttpClient } from "@/core/http/types";
import type { Task, TaskStatus } from "@/domains/Tasks/types";

export interface PortalTasks {
  tasks: Task[];
  count: number;
  /** A client-role session edits. Brief-share, admin-preview and creator
   * sessions read only. */
  canEdit: boolean;
}

export const portalTasksService = {
  list(http: HttpClient, status: TaskStatus): Promise<PortalTasks> {
    return http.get<PortalTasks>(`/api/client-portal/tasks?status=${status}`);
  },
};
